module.exports = __webpack_public_path__ + "static/img/手术进度@3x.6054451.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/手术进度@3x.png
// module id = 315
// module chunks = 379 380